module.exports = "../../../../platform/assets/pageMainIcon/jichudanganlei7.svg";